import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import AuthLayout from "@/pages/Layout/AuthLayout.vue";

// Challenges
import Challenges from "@/pages/Dashboard/Challenges.vue";
import ChallengeView from "../pages/Dashboard/ChallengeView.vue";
import ChallengeManualActivity from "../pages/Dashboard/ChallengeManualActivity";
import ShoppingSystem from "../pages/Dashboard/ShoppingSystem";
// @TODO: change this to local page - it's not part of atomic design
import Notifications from "sports4me-web_components/atomic-design/pages/notifications";

// Pages
import ChallengeList from "@/pages/Homepage/ChallengeList.vue";
import PublicChallengeDetails from "@/pages/Homepage/PublicChallengeDetails.vue";
import Login from "@/pages/Dashboard/Pages/Login.vue";
import Register from "@/pages/Dashboard/Pages/Register.vue";
import Settings from "../pages/Dashboard/Pages/UserProfile/Settings";
import Admin from "../pages/Dashboard/Pages/UserProfile/Admin";
import Friends from "../pages/Dashboard/Pages/UserProfile/Friends";
import EditProfileForm from "../pages/Dashboard/Pages/UserProfile/EditProfileForm";
// @TODO: change this to local page - it's not part of atomic design
import BadgesPage from "@/components/badged-page";

import Strava from "../pages/Dashboard/Pages/Apps/Strava";
import Garmin from "../pages/Dashboard/Pages/Apps/Garmin";
import Polar from "../pages/Dashboard/Pages/Apps/Polar";
import Suunto from "../pages/Dashboard/Pages/Apps/Suunto";
import Fitbit from "../pages/Dashboard/Pages/Apps/Fitbit";
import Feed from "../pages/Dashboard/Pages/Feed";
import Kontakt from "../pages/Dashboard/Pages/Contact";
import ResetPassword from "../pages/Dashboard/Pages/ResetPassword";
import PrivateChallenge from "../pages/Dashboard/PrivateChallenge";
import PrivateChallengeDetails from "@/pages/Dashboard/PrivateChallengeDetails";
import ActivityDetails from "../pages/Dashboard/ActivityDetails";
// @TODO: change this to local page - it's not part of atomic design
import UserProfile from "@/components/UserProfile";
import EditRegistrationForm from "../pages/Dashboard/EditRegistrationForm";

let pagesMenu = {
  path: "/pages",
  component: DashboardLayout,
  name: "Pages",
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: "user/:id",
      name: "User Page",
      components: { default: UserProfile },
    },
    {
      path: "user/:id/edit",
      name: "Edit Page",
      components: {default: EditProfileForm },
    },
    {
      path: "badges",
      name: "badges Page",
      components: {default: BadgesPage },
    },
    {
      path: "settings",
      name: "Settings",
      components: { default: Settings }
    },
    {
      path: "_register",
      name: "RegisterPages",
      component: Register
    },
    {
      path: "admin",
      name: "Admin",
      components: { default: Admin }
    },
    {
      path: "friends",
      name: "Friends",
      component: require("../pages/Dashboard/Pages/UserProfile/Friends").default
    },
  ]
};

let authPages = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  children: [
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        authRed: true,
        canRedirectAfterLogin: true
      }
    },
    {
      path: "/register",
      name: "Register",
      component: Register,
      meta: {
        authRed: true,
        canRedirectAfterLogin: true
      }
    },
    {
      path: "/reset",
      name: "ResetPasswort",
      component: ResetPassword
    },
    {
      path: "/challengeList",
      name: "ChallengeList",
      component: ChallengeList,
      meta: {
        authRed: true
      }
    },
    {
      path: "/publicChallengeDetails/:id",
      name: "PublicChallengeDetails",
      component: PublicChallengeDetails,
      meta: {
        authRed: true
      }
    }
  ]
};

const routes = [
  {
    path: "/",
    redirect: "/Challenges",
  },
  pagesMenu,
  authPages,
  {
    path: "/",
    component: DashboardLayout,
    children: [
      {
        path: "Challenges",
        name: "Challenges",
        component: Challenges,
        meta: {
          requiresAuth: true
        },
      },
      {
        path: "Challenges/private",
        name: "private",
        component: PrivateChallenge,
        meta: {
          requiresAuth: true
        },
      },
      {
        path: "Challenges/private/:id",
        name: "private-challenge-details",
        component: PrivateChallengeDetails,
        meta: {
          requiresAuth: true
        },
      },
      {
        path: "Challenges/:id",
        name: "ChallengePage",
        alias: "_PublicChallengeDetails/:id",
        component: ChallengeView,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "challenges/:id/activity",
        name: "ChallengeManualActivity",
        component: ChallengeManualActivity,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "challenges/:id/cart",
        name: "ShoppingSystemPage",
        component: ShoppingSystem,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "challenges/:id/edit-registration",
        name: "EditChallengeRegistrationPage",
        component: EditRegistrationForm,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "notifications",
        name: "NotificationsPage",
        component: Notifications,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/strava",
        name: "Strava",
        component: Strava,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/garmin",
        name: "Garmin",
        component: Garmin,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/polar",
        name: "Polar",
        component: Polar,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/suunto",
        name: "Suunto",
        component: Suunto,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/fitbit",
        name: "Fitbit",
        component: Fitbit,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/Feed",
        name: "Feed",
        component: Feed,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "activity/:id",
        name: "ActivityDetails",
        component: ActivityDetails,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/contact",
        name: "Kontakt",
        component: Kontakt
      }
    ]
  }
];

export default routes;
